const statesToText = {
  sent: 'Подбор техники',
  new: 'Подбор техники',
  tender: 'Подбор техники',
  taken: 'Подбор техники',
  assigned: 'Подбор техники',
  active: 'Активен',
  close: 'Закрыт',
  cancelled: 'Отменен',
  done: 'Завершен',
  annulled: 'Аннулирован',
}

const statesToColor = {
  sent: 'warning',
  new: 'warning',
  tender: 'warning',
  taken: 'success',
  active: 'success',
  assigned: 'success',
  close: 'grey',
  cancelled: 'grey',
  done: 'grey',
  archive: 'grey',
  annulled: 'error',
}

const byState = (state) => {
  switch (state) {
    case 'sent':
    case 'new': return 'new'
    case 'assigned': return 'assigned'
    case 'taken': return 'taken'
    case 'active':
    case 'close': return 'active'
    case 'cancelled': return 'cancelled'
    case 'tender': return 'tender'
    case 'done': return 'close'
    default: return 'new'
  }
}

export {
  statesToText,
  statesToColor,
  byState,
}
